import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCompanyDetails } from "./CompanySingleAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCompanyDetailsAsync = createAsyncThunk(
  "JobDetails/fetch",
  async ({ uuid }, { rejectWithValue }) => {
    try {
      const data = await fetchCompanyDetails(uuid);

      const resp = data.response;
      // console.log("async company details", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




const CompanySingleSlice = createSlice({
  name: "CompanySingle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyDetailsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyDetailsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCompanyDetailsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.data = null; // Clear data on error
      });
  },
});


export const selectCompanyDetails = (state) => state.companyDetails.data;

export default CompanySingleSlice.reducer;
